<template>
	<EMCoreTemplate category="System" identity="entitlement" entity="osm_product"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/SystemManagement/containers/Entitlement.vue